import BundleItemProductCard from './BundleItemProductCard';

export default BundleItemProductCard;
